import { vMaska } from 'maska/vue';
import { defineNuxtPlugin } from '#app/nuxt';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('maska', vMaska);
});
